import React, { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getTranslator } from '../../i18n/getTranslator';
import { updateFilter, radiusSelector } from '../../../reducers/filters';
import { SelectRadiusOptions } from '../../../search/common/SelectRadiusOptions';
import searchTranslations from 'public/locales/en/search.json';
import { DropdownWithLabel } from '@blueprint/dropdown';

const t = getTranslator(searchTranslations);

export const SelectRadius = () => {
    const reduxDispatch = useDispatch();
    const { selectedValue, options } = useSelector(radiusSelector);

    const onRadiusChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('radius', evt.currentTarget.value));
    };
    const radiusLabel = t('filters.searchRadius');

    return (
        <DropdownWithLabel
            id="desktop_radius-filter"
            data-testid="desktop_radius-filter"
            onChange={onRadiusChange}
            value={selectedValue}
            name="radius"
            aria-label="Radius"
            label={radiusLabel}
            hasExtendedHeight
            hasNoLeftRightBorder
        >
            {options.length ? (
                <SelectRadiusOptions
                    keyPrefix="quicksearch"
                    options={options}
                />
            ) : null}
        </DropdownWithLabel>
    );
};
